function StepperProgressBar () { 
   return <svg width="273" height="16" viewBox="0 0 273 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 8L128.5 8.00001" stroke="#AAAAAA" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="4 4"/>
        <path d="M134.5 14L139.167 8.16667L134.5 2.33333" stroke="#AAAAAA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M144.5 8L272 8.00001" stroke="#AAAAAA" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="4 4"/>
    </svg>
    
}

export default StepperProgressBar